<template>
  <div id="about-visit">
    <div v-if="apiPath === 'Create'">
      <van-cell-group>
        <van-field v-model="VisitName" required clearable label="参观项目：" placeholder="参观项目" />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="currentDate"
          required
          label="参观时间："
          disabled
          @click="clickVisitDateTime"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field v-model="VisitProCount" required clearable label="参观人数：" placeholder="参观人数" />
      </van-cell-group>

      <van-cell-group>
        <van-field v-model="ResponsibleName" required clearable label="负责人姓名：" placeholder="负责人姓名" />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="ResponsiblePhone"
          required
          clearable
          label="负责人电话："
          placeholder="负责人电话"
        />
      </van-cell-group>

      <van-cell-group class="beizhu">
        <van-field v-model="Explain" type="textarea" clearable label="备注：" placeholder />
      </van-cell-group>

      <div class="mask" v-if="VisitDateTimeShow" @click.prevent="clickMask"></div>
      <van-datetime-picker
        v-if="VisitDateTimeShow"
        v-model="VisitDateTime"
        @confirm="confirm"
        @cancel="clickMask"
        type="datetime"
      />
    </div>

    <div v-if="apiPath === 'EditState'|| apiPath === 'Examine'">
      <van-cell title="参观项目：" :value="VisitName" size="large" />
      <van-cell title="参观时间：" :value="VisitDateTime" size="large" />
      <van-cell title="参观人数：" :value="VisitProCount" size="large" />
      <van-cell title="负责人姓名：" :value="ResponsibleName" size="large" />
      <van-cell title="负责人电话：" :value="ResponsiblePhone" size="large" />
      <van-cell title="备注：" :value="Explain" size="large" />

      <van-cell v-if="apiPath === 'Examine'" title="申请人：" :value="CreatedUserName" size="large" />
      <van-cell
        v-if="apiPath === 'Examine'"
        title="申请人用户名："
        :value="UserName"
        size="large"
      />

      <van-cell v-if="isinfo" title :value="isShowInfo" size="large" class="text-right" />
      <div class="select-btn clearfix" v-show="isShow&&apiPath==='Examine'">
        <van-button
          v-if="isShow&&apiPath==='Examine'"
          :loading="loading"
          size="large"
          type="info"
          loading-text="通过..."
          @click.native="examineButton(2)"
          class="creatBtn"
        >通过</van-button>
        <van-button
          v-if="isShow&&apiPath==='Examine'"
          :loading="falseloading"
          size="large"
          type="info"
          loading-text="拒绝..."
          @click.native="examineButton(3)"
          class="creatBtn"
        >拒绝</van-button>
      </div>
    </div>
    <van-button
      v-if="isShow&&apiPath!=='Examine'"
      :loading="loading"
      size="large"
      type="info"
      loading-text="加载中..."
      @click.native="saveVisit"
      class="creatBtn"
    >{{bottonText}}</van-button>
  </div>
</template>

<script>
// TODO   VisitDetail从消息列表点击进入
export default {
  components: {},
  data() {
    return {
      loading: false, //保存中状态
      falseloading: false,
      VisitName: "",
      currentDate: new Date().pattern('yyyy-MM-dd HH:mm:ss'),
      VisitProCount: "",
      ResponsibleName: "",
      ResponsiblePhone: "",
      Explain: "",
      apiPath: "Create",
      VisitDateTime: "",
      VisitDateTimeShow: false,
      bottonText: "",
      isShow: true,
      isinfo: false,
      isShowInfo: "",
      VisitID: 0,
      undoDataArray: [],
      CreatedUserName: "",
      UserName: ""
    };
  },

  created: function() {},
  mounted: function() {
    this.apiPath = this.$route.query.params;
    if(this.$route.query.loadParams){
      this.undoDataArray = JSON.parse(this.$route.query.loadParams);
    }


    this.configBotton();
  },
  methods: {
    clickVisitDateTime() {
      this.VisitDateTimeShow = true;
    },
    clickMask() {
      this.VisitDateTimeShow = false;
    },
    confirm(val) {
      //点击确认
      this.currentDate = new Date(val).pattern('yyyy-MM-dd HH:mm:ss');
      this.VisitDateTimeShow = false;
    },
    saveVisit() {
      if (this.apiPath === "Create") {
        // 提交
        this.submit();
      } else if (this.apiPath === "EditState") {
        // 撤销
        this.undo();
      }
    },
    configBotton() {
      if (this.apiPath === "Create") {
        this.VisitDateTime = new Date();
        this.bottonText = "提交";
      } else if (this.apiPath === "EditState") {
        this.undoData();
        this.bottonText = "撤销";
      } else if (this.apiPath === "Examine") {
        this.undoData();
      }
    },
    undoData() {
      let row = this.undoDataArray;
      console.log(row);
      this.VisitID = row.VisitID;
      this.Explain = row.Explain;
      this.ResponsiblePhone = row.ResponsiblePhone;
      this.ResponsibleName = row.ResponsibleName;
      this.VisitProCount = row.VisitProCount;
      this.VisitDateTime = row.VisitDateTime;
      this.VisitName = row.VisitName;
      if (this.apiPath === "Examine") {
        this.CreatedUserName = row.CreatedUserName;
        this.UserName = row.UserName;
      }
      if (row.VisitState !== 1) {
        this.isShow = false;
        this.isinfo = true;
        this.isShowInfo = row.VisitStateName;
        console.log(row.VisitStateName);
      }
    },
    async submit() {
      if (
        this.VisitName.replace(/\s*/g, "") === "" ||
        this.VisitName.replace(/\s*/g, "").length > 20
      ) {
        this.xy.msgError("参观项目不能为空并且不能超过20字符");
        return false;
      }

      this.VisitDateTime = new Date(this.VisitDateTime).pattern('yyyy-MM-dd HH:mm:ss');

      if (this.VisitProCount.replace(/\s*/g, "") === "") {
        this.xy.msgError("参观人数不能为空");
        return false;
      } else {
        var reg = /^[0-9]{1,3}$/;
        var housenumberValid = this.VisitProCount.replace(/\s*/g, "");
        if (!reg.test(housenumberValid)) {
          this.xy.msgError("参观人数只能输入0-999的数字");
          return false;
        }
      }

      if (
        this.ResponsibleName.replace(/\s*/g, "") === "" ||
        this.ResponsibleName.replace(/\s*/g, "").length > 20
      ) {
        this.xy.msgError("负责人姓名不能为空并且不能超过20字符");
        return false;
      }

      if (this.ResponsiblePhone.replace(/\s*/g, "") === "") {
        this.xy.msgError("负责人电话不能为空");
        return false;
      } else {
        // eslint-disable-next-line no-redeclare
        var reg = /^(((\d{3}|\d{4})-)?(\d{8}|\d{4}|\d{5}|\d{6}|\d{7}|\d{11}))$|(1(3[0-9]|4[57]|5[0-35-9]|66|7[0135678]|8[0-9]|9[8-9])\d{8})$/;
        // eslint-disable-next-line no-redeclare
        var housenumberValid = this.ResponsiblePhone.replace(/\s*/g, "");
        if (!reg.test(housenumberValid)) {
          this.xy.msgError("负责人电话格式错误");
          return false;
        }
      }

      if (this.Explain.replace(/\s*/g, "").length > 200) {
        this.xy.msgError("备注不能超过200字符");
        return false;
      }

      this.loading = true;

      let res = await this.xyapi.post(
        this.$store.state.apiPath + "/api/Visit/" + this.apiPath,
        {

          VisitName: this.VisitName,
          VisitDateTime: this.VisitDateTime,
          VisitProCount: this.VisitProCount,
          ResponsibleName: this.ResponsibleName,
          ResponsiblePhone: this.ResponsiblePhone,
          Explain: this.Explain
        }
      );
      this.loading = false;
      if (res.success) {
        this.xy.msgSuc("创建成功！");
        this.$router.push(`/home/Visit`);
      } else {
        this.xy.msgError(res.data.msg);
      }
    },
    undo() {
      this.xy.confirm("撤销提示", "你确定要撤销当前申请吗？", async () => {
        this.loading = true;
        let res = await this.xyapi.post(
          this.$store.state.apiPath +
            "/api/Visit/" +
            this.apiPath +
            `?visitState=${4}&&visitID=${this.VisitID}`
        );
        console.log(res);
        this.loading = false;
        if (res.success) {
          this.xy.msgSuc("撤销成功！");
          //   xy.http.load(xy.subMenuWebUrl + "/View/oaVisit/VisitApply/Mobile/View/Visit.html", { targetID: "XyContent" }, function () { });
          this.$router.push(`/home/Visit`);
        } else {
          this.xy.msgError(res.msg);
        }
      });
    },
    examineButton(visitState) {
      var visitStateName = "通过";
      if (visitState === 3) {
        visitStateName = "拒绝";
      }
      this.xy.confirm(
        "审批提示",
        "你确定要" + visitStateName + "当前申请吗？",
        async () => {
          this.loading = true;

          if (visitState === 3) {
            this.falseloading = true;
            this.loading = false;
          } else {
            this.loading = true;
            this.falseloading = false;
          }
          let res = await this.xyapi.post(
            this.$store.state.apiPath +
              `/api/Visit/EditState?visitState=${visitState}&&visitID=${this.VisitID}`
          );
          console.log(res, visitState);
          this.loading = false;
          if (res.success) {

            this.falseloading = false;
            this.loading = false;
            this.xy.msgSuc("审批成功！");
            this.$router.push(`/home/Examine`);
          } else {
            this.xy.msgError(res.msg);
          }
        }
      );
    }
  }
};
</script>
<style lang='less' >
#about-visit {
  input {
    height: 100%;
  }
  .mask {
    z-index: 9;
    background-color: rgba(0, 0, 0, 0.5);
    pointer-events: auto;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
  }
  .van-picker {
    bottom: 0;
    position: absolute;
    width: 100%;
    z-index: 999;
  }
  .van-cell-group,
  .van-cell--large {
    margin-top: 20px;
  }
  .creatBtn {
    margin-top: 50px;
    height: 90px;
    line-height: 90px;
    font-size: 30px;
  }
  .beizhu {
    .van-field__label {
      width: 100px;
      span {
        display: block;
        height: 100%;
        line-height: 100%;
      }
    }
  }
  .van-cell--large .van-cell__title {
    font-size: 28px;
  }
  .van-cell__value,
  .van-cell--large .van-cell__title {
    color: #525252;
  }
  .text-right {
    span {
      float: right;
    }
  }
}
</style>

